import { useEffect, useState } from 'react';

export interface UseIsIndeterminateProps {
  allChainPaths: string[];
  currentProjectSubchains: string[];
  isLoadingAddChainsToProjects?: boolean;
  isSelected: boolean;
}

interface CheckIsIndeterminateParams
  extends Omit<UseIsIndeterminateProps, 'isLoadingAddChainsToProjects'> {}

const checkIsIndeterminate = ({
  allChainPaths,
  currentProjectSubchains,
  isSelected,
}: CheckIsIndeterminateParams) =>
  allChainPaths.some(path => currentProjectSubchains.includes(path)) &&
  !isSelected;

export const useIsIndeterminate = ({
  allChainPaths,
  currentProjectSubchains,
  isLoadingAddChainsToProjects,
  isSelected,
}: UseIsIndeterminateProps) => {
  const [isIndeterminate, setIsSelected] = useState(
    checkIsIndeterminate({
      allChainPaths,
      currentProjectSubchains,
      isSelected,
    }),
  );

  useEffect(() => {
    if (!isLoadingAddChainsToProjects) {
      setIsSelected(
        checkIsIndeterminate({
          allChainPaths,
          currentProjectSubchains,
          isSelected,
        }),
      );
    }
  }, [
    allChainPaths,
    currentProjectSubchains,
    isLoadingAddChainsToProjects,
    isSelected,
  ]);

  return isIndeterminate;
};
